<app-slider
  [control]="form.get('value')"
  [colorfulSlideBar]="true"
  [sliderData]="{
    title: 'ANALYSES.SINGLE.STRESS_LEVEL',
    lowValue: 'ANALYSES.SINGLE.NO_STRESS',
    highValue: 'ANALYSES.SINGLE.EXTREME_STRESS',
  }"
  [min]="question.answers[0].min"
  [max]="question.answers[0].max"
  (valueChanged)="track()"
/>

<small
  *ngIf="form.get('value').touched && form.get('value').errors?.min"
  class="form-text text-danger gpt-8 gpl-16"
>
  {{ 'MIN_VALUE' | translate }}
</small>
